import { render, staticRenderFns } from "./OrdManageSave.vue?vue&type=template&id=ce5e7178&scoped=true"
import script from "./OrdManageSave.vue?vue&type=script&lang=js"
export * from "./OrdManageSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5e7178",
  null
  
)

export default component.exports